import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

module.exports = {
    /*createFetchParams: accounts => ({accounts})*/
    createFetchParams: (pagination, accounts, ordering = {}, filters = {}) => ({
        ...pagination,
        ...filters,
        accounts,
        ordering
    }),
    ...storeModuleFactory({
        name:     'costCenters',
        endpoint: endpoints.costcenters.endpoint,
        timeout:  TIMEOUT_STORE.TIMEOUT_STORE_SMALL
    })
};



// WEBPACK FOOTER //
// ./src/modules/store/costCenters.js